import { gql } from '@edreamsodigeo/frontend-api-client';
import { api as airlineTrackingPositionFragment } from './airlineTrackingPosition';

export const api = gql`
  fragment AirlineTrackingInfo on AirlineTracking {
    carrier
    sortingPosition {
      ...AirlineTrackingPositionInfo
    }
    preBoostingPosition {
      ...AirlineTrackingPositionInfo
    }
  }
  ${airlineTrackingPositionFragment}
`;
